import { render, staticRenderFns } from "./IdentificationPhotosEmpty.vue?vue&type=template&id=00670c87&scoped=true"
import script from "./IdentificationPhotosEmpty.vue?vue&type=script&lang=js"
export * from "./IdentificationPhotosEmpty.vue?vue&type=script&lang=js"
import style0 from "./IdentificationPhotosEmpty.vue?vue&type=style&index=0&id=00670c87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00670c87",
  null
  
)

export default component.exports